export const testimonials = [
  {
    name: 'Lucía',
    role: 'Physiotherapist',
    country: 'Spain',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/f740cb24-5cdc-443b-8ada-1abdf9675818.jpg',
    quote: 'The initial assessment framework gave my interviews a clear order. I now finish the subjective part knowing exactly what I still need to explore.',
  },
  {
    name: 'Daniel',
    role: 'Physical Therapist',
    country: 'Mexico',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/1ff7118e-1ddd-4472-8de9-e54b8b5b5c30.jpg',
    quote: 'The red flag worksheet is the resource I open most. It helps me document my screening and explain why I did or didn’t consider referral.',
  },
  {
    name: 'Emma',
    role: 'Physiotherapy Student',
    country: 'Canada',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/515c424a-5cef-4786-8e30-3f2938ceac6b.jpg',
    quote: 'Working through the casebook before placements helped me practice connecting history and exam findings instead of memorizing isolated tests.',
  },
  {
    name: 'Samuel',
    role: 'Sports Physiotherapist',
    country: 'United Kingdom',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/8eee90f1-0b0d-4601-9cab-2f753b06c92b.jpg',
    quote: 'The clinical reasoning matrix made my notes far more transparent. I can see at a glance what supports a hypothesis and what is still missing.',
  },
  {
    name: 'Carmen',
    role: 'Senior Physiotherapist',
    country: 'Argentina',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/6e633b15-3860-4ba9-b9f9-c38b2f4e9b1b.jpg',
    quote: 'After many years in practice it was refreshing to review my whole assessment process in one organized collection. I use it with my junior colleagues too.',
  },
];
